import { Text } from "../../ui-kit/Text/Text";

export const NotFound = () => {
  return (
    <div>
      <Text title>Страница не найдена</Text>
    </div>
  );
};
